import { clearTranslationCache } from '../api/languageService';

// Function to refresh translations after upload
export const refreshTranslations = () => {
  // Clear the cache to force reload from backend
  clearTranslationCache();
  
  // Dispatch a custom event to notify components to reload translations
  window.dispatchEvent(new CustomEvent('translationsUpdated'));
  
  // Optionally reload the page to ensure all components get fresh translations
  // window.location.reload();
};

// Function to listen for translation updates
export const onTranslationsUpdated = (callback) => {
  const handleUpdate = () => {
    callback();
  };
  
  window.addEventListener('translationsUpdated', handleUpdate);
  
  // Return cleanup function
  return () => {
    window.removeEventListener('translationsUpdated', handleUpdate);
  };
};
